// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input_calendar.mid[data-v-5f06eea8], .input_calendar.mid input[data-v-5f06eea8] {\n    width: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
